let infoKey='shopUserInfo'

export const getInfo=()=>{
    const result= localStorage.getItem(infoKey)
    return result? result:{userid:'',Token:''}
}

export const setUserInfo=(value)=>{
     console.log(value);
     
     localStorage.setItem(infoKey,JSON.stringify(value))
}

export const removeUserinfo=()=>{
    localStorage.removeItem(infoKey)
}